import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesInternalBank } from "../../constants";
import { UpdateExpenseBody } from "./updateExpense.types";

export const requestUpdateExpense = async ({
  id,
  ...body
}: UpdateExpenseBody): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesInternalBank.Expenses, id),
    body
  );
};
